import React, { useEffect, useState } from 'react';
import { GET_REVENUE } from 'src/apiService/apiDeclaration';
import { Grid, Skeleton, Typography } from '@mui/material';
import { revenueSectionIcons } from 'src/constants';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import RevenueCard from './RevenueCard';
import { t } from 'i18next';

const RevenueSection = () => {
  const [revenue, setRevenue] = useState();

  const getRevenue = async () => {
    try {
      let resp = await GET_REVENUE();
      setRevenue(resp.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const colors = ['#AA2B62', '#e5bd44', '#ff6e39', '#2c6fbb', '#46BE93'];

  const routing = {
    today: { to: '/revenue', status: 'DAILY' },
    thisWeek: { to: '/revenue', status: 'WEEKLY' },
    thisMonth: { to: '/revenue', status: 'MONTHLY' },
    thisQuarter: { to: '/revenue', status: 'QUARTERLY' },
    thisYear: { to: '/revenue', status: 'YEARLY' },
  };

  useEffect(() => {
    getRevenue();
  }, []);
  return (
    <>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
        <AttachMoneyIcon sx={{ fontSize: '2.5rem', color: '#acd629' }} />
        <Typography variant="h4">{t('revenue.revenue')}</Typography>
      </Grid>
      <Grid container gap={{ sm: 3, xs: 1.5 }} sx={{ justifyContent: { md: 'start', xs: 'center' }, py: 2 }}>
        {revenue
          ? Object.entries(revenue).map(([key, value], index) => (
              <RevenueCard
                key={key}
                path={routing[key]}
                title={key}
                value={value}
                icon={revenueSectionIcons[index]}
                bgColor={colors[index]}
              />
            ))
          : Array(5)
              .fill(null)
              .map((_, index) => {
                return (
                  <Skeleton
                    key={index}
                    animation="wave"
                    sx={{ borderRadius: '12px' }}
                    variant="rectangular"
                    width={260}
                    height={140}
                  />
                );
              })}
      </Grid>
    </>
  );
};

export default RevenueSection;
